
import React from 'react';
import { cn } from '@/lib/utils';
import TimeRangeSelector from './charts/TimeRangeSelector';
import ConsumptionAreaChart from './charts/ConsumptionAreaChart';
import { useConsumptionData } from '@/hooks/useConsumptionData';

interface ConsumerConsumptionChartProps {
  userId: string;
  className?: string;
}

const ConsumerConsumptionChart: React.FC<ConsumerConsumptionChartProps> = ({ userId, className }) => {
  const { 
    timeRange, 
    setTimeRange, 
    hideConsumption, 
    toggleConsumptionVisibility, 
    consumptionData 
  } = useConsumptionData(userId);
  
  // Add energy/water/gas-specific styling based on userId
  const getThemeColor = () => {
    if (userId.includes('energy')) return 'border-orange-100 dark:border-orange-900/30';
    if (userId.includes('water')) return 'border-cyan-100 dark:border-cyan-900/30';
    if (userId.includes('gas')) return 'border-amber-100 dark:border-amber-900/30';
    return 'border-blue-100 dark:border-blue-900/30';
  };

  return (
    <div className={cn(
      "bg-white/80 dark:bg-gray-800/30 p-2 rounded-lg h-full flex flex-col", 
      getThemeColor(),
      className
    )}>
      <TimeRangeSelector 
        timeRange={timeRange} 
        onTimeRangeChange={setTimeRange}
        className="mb-1 flex-shrink-0"
      />
      
      <div className="flex-1 min-h-0 w-full relative">
        <div className="absolute inset-0">
          <ConsumptionAreaChart 
            data={consumptionData}
            hideConsumption={hideConsumption} 
            onLegendClick={toggleConsumptionVisibility}
            timeRange={timeRange}
          />
        </div>
      </div>
    </div>
  );
};

export default ConsumerConsumptionChart;
